var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The fill colors of this icon and all filled icons are hardcoded because:
 * - simplicty
 * - we will not need to change them
 */
export var SpringHealthLogo = function (_a) {
    var props = __rest(_a, []);
    return (_jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M11.4456 6.9199C9.47414 8.58731 7.83168 10.37 6.46204 12.1555C9.58944 9.99322 13.2653 8.87693 16.9299 9.12999C19.7085 9.32401 22.2481 10.3419 24.0762 11.4132C24.0762 11.4132 24.7793 10.2294 24.3743 4.82509C24.1577 1.91766 24.349 0 24.349 0C21.6631 0.165898 15.0287 3.88594 11.4513 6.91709L11.4456 6.9199Z", fill: "#01382E" }), _jsx("path", { d: "M16.7988 10.9829C12.5998 10.6905 8.36999 12.4479 5.18353 15.6224C7.14659 14.5202 9.734 13.6682 12.898 13.9157C17.1503 14.2531 20.1146 16.4941 21.8414 18.2965C22.8145 16.8681 23.481 15.2147 23.7426 13.432C22.0242 12.2736 19.6815 11.1798 16.8016 10.9801L16.7988 10.9829Z", fill: "#01382E" }), _jsx("path", { d: "M12.7515 15.7743C7.04509 15.3216 3.47333 19.0389 2.51711 20.1861C1.81964 21.0268 1.24028 21.9716 0.793107 22.9979C0.739671 23.1666 0.686239 23.3325 0.638428 23.4928C0.638428 23.4928 5.18328 24.4769 12.189 23.7037C19.1919 22.9304 20.6656 19.7587 20.6656 19.7587C19.2031 18.1728 16.5791 16.0808 12.7486 15.7772L12.7515 15.7743Z", fill: "#01382E" }), _jsx("path", { d: "M10.2424 5.50272C12.8861 3.26451 15.8672 1.41153 19.0537 0.00280762L12.1127 0.0477966C5.6582 0.0871621 0.458069 5.3565 0.500255 11.8124L0.542431 18.4736C2.3255 14.5118 5.31509 9.67545 10.2396 5.50272H10.2424Z", fill: "#01382E" })] })));
};
